var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNotEqual(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F1D9B1D2-C3D9-4966-B215-31116F2AA6AC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Entity-Details",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TaxPro-Entity-Details-IntLink-1.0-Balance-4",
    transform: "translate(-745.000000, -646.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Equal-Not",
    transform: "translate(745.000000, 646.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    stroke: "#F4CD52",
    fill: "#FEF7E0",
    cx: 12,
    cy: 12,
    r: 9.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Equal"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6627502,6.63232475 L17.3714476,7.33783732 L15.7164717,8.99932475 L17,9 L17,11 L13.7254717,10.9993248 L11.7344717,12.9993248 L17,13 L17,15 L9.74347166,14.9993248 L7.35316907,17.4013405 L6.64447166,16.6958279 L8.33247166,14.9993248 L7,15 L7,13 L10.3234717,12.9993248 L12.3154717,10.9993248 L7,11 L7,9 L14.3064717,8.99932475 L16.6627502,6.63232475 Z",
    id: "Combined-Shape",
    fill: "#82703A"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotEqual);
export default __webpack_public_path__ + "static/media/IconNotEqual.8478776b.svg";
export { ForwardRef as ReactComponent };